<script lang="ts" setup>
import JyHeader from 'components/header/index.vue'
import JyNav from 'components/nav/index.vue'
import { commonStore } from '@/stores/common'
import { useUserStore } from '@/stores/user'
const common = commonStore()

const user = useUserStore()
const appName = __APP__NAME
</script>

<template>
  <el-container class="jy-layout">
    <el-header>
      <jy-header :app-name="appName" :user="user" />
    </el-header>
    <el-main>
      <el-container class="jy-layout-main-container">
        <el-aside v-if="common.isShowMenu">
          <jy-nav :permission-list="common.permissionList || []" :active-resource-url="common.activeResourceUrl" />
        </el-aside>
        <el-main class="jy-layout-main-content">
          <router-view :key="$route.fullPath" />
        </el-main>
      </el-container>
    </el-main>
  </el-container>
</template>

<style lang="scss">
.jy-layout {
  .el-header {
    padding: 0;
  }

  .el-main {
    padding: 0;

    .jy-layout-main-container {
      height: calc(100vh - 60px);
    }

    .el-aside {
      width: 240px;
      height: 100%;
    }

    .jy-layout-main-content {
      padding: 0 10px 10px;
    }
  }
}
</style>
